import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NavigationLabelComponent } from '../navigation-label/navigation-label.component';
import { TranslateModule } from '@ngx-translate/core';
import { AppNavigationSection } from '../../app.navigation';
import { BrokenImportsButtonComponent } from '../../buttons';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { RouterLink } from '@angular/router';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { IcsLoadingSpinnerDirective } from 'ics-core';

@Component({
  selector: 'app-navigation-card',
  template: `
    <mat-card appearance="outlined" class="navigation-card">
      <mat-card-header>
        <mat-card-title>{{ route().label | translate }}</mat-card-title>
      </mat-card-header>

      <mat-divider />

      <mat-card-content>
        <mat-nav-list>
          @for (childRoute of route().items; track childRoute) {
            <div class="row center-alignment">
              <a
                mat-list-item
                [routerLink]="route().link + '/' + childRoute.link">
                <app-navigation-label
                  #itemLabelRef
                  [navigationItem]="childRoute"
                  matListItemTitle />
              </a>

              @if (itemLabelRef.showBadge()) {
                @if (itemLabelRef.incompleteCount() > 0) {
                  <app-broken-imports-button
                    [route]="[route().link, childRoute.link]" />
                }
              } @else {
                @if (itemLabelRef.showBadge()) {
                  <mat-progress-spinner icsLoadingSpinner size="small" />
                }
              }
            </div>
          }
        </mat-nav-list>
      </mat-card-content>
    </mat-card>
  `,
  styleUrls: ['./navigation-card.component.scss'],
  imports: [
    NavigationLabelComponent,
    TranslateModule,
    MatCardModule,
    MatListModule,
    RouterLink,
    BrokenImportsButtonComponent,
    MatProgressSpinner,
    IcsLoadingSpinnerDirective,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NavigationCardComponent {
  readonly route = input.required<AppNavigationSection>();
}
